// extracted by mini-css-extract-plugin
export default {"button":"MainButtonWithBackground_button__0mvMU"};